import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import RawdemandEditForm from './RawdemandEditForm';
import RawdemandList from './RawdemandList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import RawdemandListView from './RawdemandListView'


export default function RawdemandDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.pharmaslice.rawdemandDashboard);
  const [ rawdemandId, setRawdemandId] = React.useState('');
  const [reloadRawdemandList, setReloadRawdemandList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <RawdemandEditForm 
            setReloadRawdemandList={setReloadRawdemandList}
            rawdemandId={rawdemandId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <RawdemandListView 
                      setRawdemandId = {setRawdemandId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
